import React from 'react';
import PropTypes from 'prop-types';

import { VpHoverInfo } from '../VpHoverInfo';
import { VpIcon } from '../';
import { StyledVpLink } from './styles';

export const MenuIcons = ({ items = [], ...rest }) => {
  return (
    <>
      {items?.map((item) => (
        <StyledVpLink
          to={item?.url.includes('http') ? { pathname: item?.url } : item?.url}
          target={item?.url.includes('http') ? '_blank' : ''}
          key={item?.url}
          {...rest}
        >
          <VpHoverInfo label={item?.text}>
            <VpIcon icon={item?.icon} />
          </VpHoverInfo>
        </StyledVpLink>
      ))}
    </>
  );
};

MenuIcons.propTypes = {
  items: PropTypes.array
};

export default MenuIcons;



// WEBPACK FOOTER //
// ./src/vp-ui/components/NavMenuIcons/MenuIcons.jsx